import { render, staticRenderFns } from "./waterdetail.vue?vue&type=template&id=b958a1d4"
import script from "./waterdetail.vue?vue&type=script&lang=js"
export * from "./waterdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports